var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g6, _g7, _g8, _g9, _g10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbUserGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 104,
    viewBox: "0 0 124 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.268 71.5065C111.268 62.8169 111.268 54.1314 111.268 45.4458C111.268 44.6418 110.618 43.9881 109.81 43.9881C95.3826 43.9881 80.9473 43.9881 66.516 43.9881C66.1749 43.9881 65.9069 44.0774 65.6348 44.2845L64.3801 45.2347C64.3761 45.2387 64.3761 45.2387 64.372 45.2428C64.0228 45.5067 63.7954 45.929 63.7954 46.4041C63.7954 55.0856 63.7954 63.7752 63.7954 72.4608C63.7954 73.2648 64.4451 73.9185 65.2532 73.9185C79.6844 73.9185 94.1157 73.9185 108.551 73.9185C108.88 73.9185 109.184 73.8089 109.428 73.6221C109.444 73.6099 109.461 73.5977 109.477 73.5856L110.691 72.6638C111.056 72.3918 111.268 71.9613 111.268 71.5065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.814 33.3535C83.814 24.6679 83.814 15.9824 83.814 7.29679C83.814 6.4928 83.1603 5.83905 82.3563 5.83905C67.925 5.83905 53.4938 5.83905 39.0625 5.83905C38.7214 5.83905 38.4534 5.92838 38.1814 6.13547L37.552 6.61462L36.9266 7.08564C36.5734 7.34958 36.3419 7.77594 36.3419 8.25103C36.3419 16.9366 36.3419 25.6262 36.3419 34.3077C36.3419 35.1158 36.9916 35.7654 37.7956 35.7654C52.2309 35.7654 66.6622 35.7654 81.0935 35.7654C81.4224 35.7654 81.7269 35.6558 81.9746 35.469V35.4731L83.2374 34.5148C83.5988 34.2387 83.814 33.8083 83.814 33.3535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7271 79.7251C55.7271 71.0436 55.7271 62.354 55.7271 53.6685C55.7271 52.8645 55.0734 52.2148 54.2694 52.2148C39.8381 52.2148 25.4069 52.2148 10.9756 52.2148C10.6345 52.2148 10.3665 52.3041 10.0944 52.5071L8.89657 53.4167C8.88845 53.4208 8.88439 53.4248 8.87627 53.4289L8.83161 53.4654C8.4824 53.7294 8.255 54.1517 8.255 54.6227C8.255 63.3123 8.255 71.9979 8.255 80.6834C8.255 81.4874 8.90876 82.1412 9.70869 82.1412C24.144 82.1412 38.5753 82.1412 53.0065 82.1412C53.3354 82.1412 53.64 82.0315 53.8836 81.8448L55.1505 80.8905C55.5119 80.6144 55.7271 80.184 55.7271 79.7251Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2091 49.5954C94.2091 49.8268 94.1603 50.0461 94.071 50.2491C93.9939 50.2613 93.9208 50.2654 93.8477 50.2654C90.0592 50.2654 86.2707 50.2654 82.4821 50.2654C81.3086 50.2654 80.5168 49.0594 80.9919 47.9833C81.0691 47.9711 81.1422 47.9671 81.2193 47.9671C85.0038 47.9671 88.7923 47.9671 92.5808 47.9671C93.4822 47.9671 94.2091 48.6939 94.2091 49.5954Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7557 11.4424C66.7557 11.6779 66.7069 11.8972 66.6176 12.1002C66.5404 12.1083 66.4673 12.1124 66.3902 12.1124C62.6017 12.1124 58.8132 12.1124 55.0247 12.1124C53.8512 12.1124 53.0634 10.9064 53.5385 9.83036C53.6116 9.81818 53.6847 9.81412 53.7618 9.81412C57.5503 9.81412 61.3388 9.81412 65.1274 9.81412C66.0247 9.81412 66.7557 10.545 66.7557 11.4424Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6685 57.8181C38.6685 58.0496 38.6197 58.2729 38.5304 58.4719C38.4573 58.4841 38.3802 58.4881 38.303 58.4881C34.5145 58.4881 30.726 58.4881 26.9415 58.4881C25.764 58.4881 24.9762 57.2821 25.4513 56.2061C25.5244 56.1939 25.6015 56.1898 25.6787 56.1898C29.4631 56.1898 33.2517 56.1898 37.0402 56.1898C37.9416 56.1898 38.6685 56.9167 38.6685 57.8181Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M111.267 45.4452C111.267 54.1307 111.267 62.8163 111.267 71.5059C111.267 71.9607 111.056 72.3911 110.691 72.6672L109.473 73.589C109.797 73.321 110.005 72.919 110.005 72.4642C110.005 63.7786 110.005 55.089 110.005 46.4035C110.005 45.5995 109.351 44.9457 108.547 44.9457C94.1156 44.9457 79.6802 44.9457 65.249 44.9457C64.9201 44.9457 64.6196 45.0554 64.38 45.234L65.6347 44.2838C65.9068 44.0808 66.1748 43.9874 66.5159 43.9874C80.9471 43.9874 95.3825 43.9874 109.81 43.9874C110.618 43.9874 111.267 44.6371 111.267 45.4452Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.992 47.9792C80.2001 48.0888 79.5911 48.767 79.5911 49.5912C79.5911 50.4886 80.3179 51.2155 81.2193 51.2155C85.0038 51.2155 88.7923 51.2155 92.5808 51.2155C93.2468 51.2155 93.8193 50.8175 94.071 50.245C94.1604 50.042 94.2091 49.8227 94.2091 49.5912C94.2091 48.6898 93.4782 47.963 92.5808 47.963C88.7923 47.963 85.0038 47.963 81.2193 47.963C81.1422 47.963 81.0691 47.9711 80.992 47.9792ZM110.005 46.3996C110.005 55.0852 110.005 63.7708 110.005 72.4604C110.005 72.9111 109.798 73.3172 109.473 73.5852C109.457 73.5973 109.44 73.6095 109.424 73.6217C109.18 73.8085 108.876 73.9181 108.547 73.9181C94.1157 73.9181 79.6804 73.9181 65.2491 73.9181C64.4451 73.9181 63.7914 73.2644 63.7914 72.4604C63.7914 63.7748 63.7914 55.0852 63.7914 46.3996C63.7914 45.9246 64.0188 45.5023 64.368 45.2383C64.368 45.2383 64.372 45.2343 64.3761 45.2343C64.6157 45.0515 64.9202 44.946 65.2451 44.946C79.6763 44.946 94.1117 44.946 108.543 44.946C109.351 44.946 110.005 45.5956 110.005 46.3996ZM104.283 63.2875C104.283 62.8084 104.283 62.3252 104.283 61.846C104.283 61.643 104.117 61.4806 103.918 61.4806C97.8474 61.4806 91.7768 61.4806 85.7063 61.4806C85.5033 61.4806 85.3408 61.643 85.3408 61.846C85.3408 62.3252 85.3408 62.8084 85.3408 63.2875C85.3408 63.4906 85.5033 63.653 85.7063 63.653C91.7768 63.653 97.8433 63.653 103.918 63.653C104.121 63.653 104.283 63.4906 104.283 63.2875ZM104.283 58.3296C104.283 57.8504 104.283 57.3672 104.283 56.8881C104.283 56.6851 104.117 56.5226 103.918 56.5226C97.8474 56.5226 91.7768 56.5226 85.7063 56.5226C85.5033 56.5226 85.3408 56.6851 85.3408 56.8881C85.3408 57.3672 85.3408 57.8504 85.3408 58.3296C85.3408 58.5326 85.5033 58.695 85.7063 58.695C91.7768 58.695 97.8433 58.695 103.918 58.695C104.121 58.695 104.283 58.5326 104.283 58.3296ZM95.1796 68.2455C95.1796 67.7664 95.1796 67.2831 95.1796 66.804C95.1796 66.601 95.0172 66.4385 94.8141 66.4385H85.7103C85.5073 66.4385 85.3449 66.601 85.3449 66.804V68.2455C85.3449 68.4485 85.5073 68.611 85.7103 68.611H94.8141C95.0172 68.611 95.1796 68.4485 95.1796 68.2455ZM83.0588 68.611C83.0588 64.5829 83.0588 60.5548 83.0588 56.5226C83.0588 56.1206 82.7339 55.7958 82.3319 55.7958C78.3039 55.7958 74.2758 55.7958 70.2436 55.7958C69.8416 55.7958 69.5168 56.1206 69.5168 56.5226C69.5168 60.5507 69.5168 64.5788 69.5168 68.611C69.5168 69.013 69.8416 69.3378 70.2436 69.3378C70.4548 69.3378 70.6619 69.3378 70.873 69.3378C74.4829 69.3378 78.0927 69.3378 81.7026 69.3378C81.9096 69.3378 82.1208 69.3378 82.3319 69.3378C82.7339 69.3378 83.0588 69.013 83.0588 68.611Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.283 61.8463C104.283 62.3255 104.283 62.8087 104.283 63.2878C104.283 63.4909 104.117 63.6533 103.918 63.6533C97.8473 63.6533 91.7767 63.6533 85.7062 63.6533C85.5031 63.6533 85.3407 63.4909 85.3407 63.2878C85.3407 62.8087 85.3407 62.3255 85.3407 61.8463C85.3407 61.6433 85.5031 61.4809 85.7062 61.4809C91.7767 61.4809 97.8432 61.4809 103.918 61.4809C104.121 61.4809 104.283 61.6474 104.283 61.8463Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.283 56.8879C104.283 57.3671 104.283 57.8503 104.283 58.3294C104.283 58.5324 104.117 58.6949 103.918 58.6949C97.8473 58.6949 91.7767 58.6949 85.7062 58.6949C85.5031 58.6949 85.3407 58.5324 85.3407 58.3294C85.3407 57.8503 85.3407 57.3671 85.3407 56.8879C85.3407 56.6849 85.5031 56.5225 85.7062 56.5225C91.7767 56.5225 97.8432 56.5225 103.918 56.5225C104.121 56.5225 104.283 56.6849 104.283 56.8879Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1796 66.8041C95.1796 67.2833 95.1796 67.7665 95.1796 68.2456C95.1796 68.4487 95.0171 68.6111 94.8141 68.6111H85.7103C85.5073 68.6111 85.3448 68.4487 85.3448 68.2456V66.8041C85.3448 66.6011 85.5073 66.4387 85.7103 66.4387H94.8141C95.0171 66.4387 95.1796 66.6011 95.1796 66.8041Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M93.8477 50.2615C93.9208 50.2615 93.9939 50.2574 94.0711 50.2452C93.8193 50.8178 93.2468 51.2157 92.5808 51.2157C88.7923 51.2157 85.0038 51.2157 81.2194 51.2157C80.3179 51.2157 79.5911 50.4889 79.5911 49.5915C79.5911 48.7672 80.2002 48.0891 80.992 47.9794C80.5169 49.0555 81.3046 50.2615 82.4822 50.2615C86.2707 50.2615 90.0592 50.2615 93.8477 50.2615Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0585 56.5228C83.0585 60.5509 83.0585 64.579 83.0585 68.6111C83.0585 69.0131 82.7336 69.338 82.3316 69.338C82.1245 69.338 81.9134 69.338 81.7023 69.338C81.2393 66.7108 78.9532 64.7942 76.2854 64.7942C73.6177 64.7942 71.3356 66.7108 70.8727 69.338C70.6616 69.338 70.4545 69.338 70.2433 69.338C69.8413 69.338 69.5165 69.0131 69.5165 68.6111C69.5165 64.5831 69.5165 60.555 69.5165 56.5228C69.5165 56.1208 69.8413 55.796 70.2433 55.796C74.2714 55.796 78.3035 55.796 82.3316 55.796C82.7336 55.796 83.0585 56.1208 83.0585 56.5228ZM78.4903 62.5528C79.1766 61.3346 78.7462 59.7956 77.528 59.1094C76.3098 58.4272 74.7709 58.8577 74.0846 60.0718C73.3984 61.2859 73.8329 62.8289 75.047 63.5151C76.2611 64.2014 77.8041 63.7669 78.4903 62.5528Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M81.7023 69.3379C78.0925 69.3379 74.4826 69.3379 70.8728 69.3379C71.3357 66.7107 73.6218 64.7942 76.2855 64.7942C78.9574 64.7982 81.2394 66.7107 81.7023 69.3379Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M77.5283 59.1094C78.7465 59.7956 79.1769 61.3346 78.4907 62.5528C77.8085 63.7709 76.2655 64.2013 75.0514 63.5151C73.8372 62.8289 73.4028 61.2899 74.089 60.0717C74.7752 58.8536 76.3101 58.4231 77.5283 59.1094Z",
    fill: "url(#paint4_linear)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.814 7.29209C83.814 15.9777 83.814 24.6632 83.814 33.3528C83.814 33.8076 83.5988 34.238 83.2374 34.5142L81.9746 35.4724C82.3238 35.2085 82.5512 34.7862 82.5512 34.3111C82.5512 25.6256 82.5512 16.94 82.5512 8.25445C82.5512 7.45046 81.9015 6.7967 81.0934 6.7967C66.6622 6.7967 52.2309 6.7967 37.7996 6.7967C37.4707 6.7967 37.1702 6.90634 36.9307 7.085L37.556 6.61398L38.1854 6.13483C38.4574 5.9318 38.7254 5.83841 39.0665 5.83841C53.4978 5.83841 67.9291 5.83841 82.3603 5.83841C83.1603 5.83841 83.814 6.4881 83.814 7.29209Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.5471 8.25064C82.5471 16.9362 82.5471 25.6218 82.5471 34.3073C82.5471 34.7824 82.3197 35.2006 81.9704 35.4686C81.7268 35.6554 81.4223 35.7651 81.0893 35.7651C66.658 35.7651 52.2268 35.7651 37.7955 35.7651C36.9915 35.7651 36.3378 35.1154 36.3378 34.3073C36.3378 25.6218 36.3378 16.9362 36.3378 8.25064C36.3378 7.77149 36.5692 7.34919 36.9225 7.08526C37.1621 6.90253 37.4666 6.79695 37.7915 6.79695C52.2227 6.79695 66.658 6.79695 81.0852 6.79695C81.8974 6.79289 82.5471 7.44665 82.5471 8.25064ZM76.8298 25.1385C76.8298 24.6594 76.8298 24.1762 76.8298 23.697C76.8298 23.494 76.6673 23.3316 76.4643 23.3316C70.3938 23.3316 64.3273 23.3316 58.2567 23.3316C58.0537 23.3316 57.8913 23.494 57.8913 23.697C57.8913 24.1762 57.8913 24.6594 57.8913 25.1385C57.8913 25.3416 58.0537 25.504 58.2567 25.504C64.3273 25.504 70.3938 25.504 76.4643 25.504C76.6673 25.4999 76.8298 25.3375 76.8298 25.1385ZM76.8298 20.1806C76.8298 19.7014 76.8298 19.2182 76.8298 18.7391C76.8298 18.5361 76.6673 18.3736 76.4643 18.3736C70.3938 18.3736 64.3273 18.3736 58.2567 18.3736C58.0537 18.3736 57.8913 18.5361 57.8913 18.7391C57.8913 19.2182 57.8913 19.7014 57.8913 20.1806C57.8913 20.3836 58.0537 20.546 58.2567 20.546C64.3273 20.546 70.3938 20.546 76.4643 20.546C76.6673 20.542 76.8298 20.3796 76.8298 20.1806ZM67.726 30.0965C67.726 29.6174 67.726 29.1342 67.726 28.655C67.726 28.452 67.5635 28.2896 67.3605 28.2896H58.2567C58.0537 28.2896 57.8913 28.452 57.8913 28.655V30.0965C57.8913 30.2995 58.0537 30.462 58.2567 30.462H67.3605C67.5635 30.462 67.726 30.2995 67.726 30.0965ZM66.6174 12.096C66.7068 11.893 66.7555 11.6737 66.7555 11.4382C66.7555 10.5408 66.0246 9.8099 65.1272 9.8099C61.3387 9.8099 57.5502 9.8099 53.7617 9.8099C53.6845 9.8099 53.6114 9.81396 53.5383 9.82614C52.7465 9.93578 52.1374 10.618 52.1374 11.4382C52.1374 12.3396 52.8643 13.0665 53.7617 13.0665C57.5502 13.0665 61.3387 13.0665 65.1272 13.0665C65.7931 13.0705 66.3657 12.6685 66.6174 12.096ZM55.6052 30.462C55.6052 26.4339 55.6052 22.4017 55.6052 18.3736C55.6052 17.9716 55.2803 17.6468 54.8783 17.6468C50.8502 17.6468 46.8222 17.6468 42.79 17.6468C42.388 17.6468 42.0632 17.9716 42.0632 18.3736C42.0632 22.4017 42.0632 26.4298 42.0632 30.462C42.0632 30.864 42.388 31.1888 42.79 31.1888C42.9971 31.1888 43.2083 31.1888 43.4194 31.1888C47.0292 31.1888 50.6391 31.1888 54.253 31.1888C54.4601 31.1888 54.6712 31.1888 54.8824 31.1888C55.2803 31.1888 55.6052 30.864 55.6052 30.462Z",
    fill: "url(#paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8297 23.6928C76.8297 24.1719 76.8297 24.6551 76.8297 25.1343C76.8297 25.3373 76.6673 25.4997 76.4643 25.4997C70.3937 25.4997 64.3272 25.4997 58.2567 25.4997C58.0537 25.4997 57.8912 25.3373 57.8912 25.1343C57.8912 24.6551 57.8912 24.1719 57.8912 23.6928C57.8912 23.4898 58.0537 23.3273 58.2567 23.3273C64.3272 23.3273 70.3937 23.3273 76.4643 23.3273C76.6673 23.3314 76.8297 23.4938 76.8297 23.6928Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8297 18.7389C76.8297 19.218 76.8297 19.7013 76.8297 20.1804C76.8297 20.3834 76.6673 20.5458 76.4643 20.5458C70.3937 20.5458 64.3272 20.5458 58.2567 20.5458C58.0537 20.5458 57.8912 20.3834 57.8912 20.1804C57.8912 19.7013 57.8912 19.218 57.8912 18.7389C57.8912 18.5359 58.0537 18.3734 58.2567 18.3734C64.3272 18.3734 70.3937 18.3734 76.4643 18.3734C76.6673 18.3734 76.8297 18.5359 76.8297 18.7389Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7259 28.6551C67.7259 29.1343 67.7259 29.6175 67.7259 30.0966C67.7259 30.2997 67.5635 30.4621 67.3605 30.4621H58.2567C58.0537 30.4621 57.8912 30.2997 57.8912 30.0966V28.6551C57.8912 28.4521 58.0537 28.2897 58.2567 28.2897H67.3605C67.5635 28.2897 67.7259 28.4521 67.7259 28.6551Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M66.3898 12.1126C66.4629 12.1126 66.5401 12.1085 66.6132 12.0963C66.3614 12.6689 65.7889 13.0668 65.1229 13.0668C61.3344 13.0668 57.5459 13.0668 53.7574 13.0668C52.86 13.0668 52.1332 12.34 52.1332 11.4385C52.1332 10.6183 52.7423 9.93611 53.5341 9.82648C53.059 10.9025 53.8467 12.1085 55.0243 12.1085C58.8128 12.1126 62.6013 12.1126 66.3898 12.1126Z",
    fill: "url(#paint7_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6051 18.3738C55.6051 22.4019 55.6051 26.43 55.6051 30.4621C55.6051 30.8641 55.2803 31.189 54.8783 31.189C54.6712 31.189 54.4601 31.189 54.2489 31.189C53.786 28.5618 51.4999 26.6452 48.8321 26.6452C46.1643 26.6452 43.8823 28.5618 43.4153 31.189C43.2082 31.189 42.9971 31.189 42.7859 31.189C42.3839 31.189 42.0591 30.8641 42.0591 30.4621C42.0591 26.434 42.0591 22.4019 42.0591 18.3738C42.0591 17.9718 42.3839 17.647 42.7859 17.647C46.814 17.647 50.8421 17.647 54.8742 17.647C55.2803 17.647 55.6051 17.9718 55.6051 18.3738ZM51.037 24.3997C51.7192 23.1815 51.2928 21.6426 50.0746 20.9563C48.8565 20.2742 47.3175 20.7046 46.6353 21.9187C45.9491 23.1369 46.3795 24.6758 47.5977 25.3621C48.8118 26.0483 50.3508 25.6179 51.037 24.3997Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M54.2489 31.1889C50.639 31.1889 47.0292 31.1889 43.4153 31.1889C43.8782 28.5617 46.1643 26.6451 48.8321 26.6451C51.4999 26.6451 53.786 28.5617 54.2489 31.1889Z",
    fill: "url(#paint8_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M50.0706 20.9566C51.2887 21.6388 51.7192 23.1818 51.0329 24.3999C50.3507 25.6181 48.8077 26.0485 47.5896 25.3623C46.3714 24.6801 45.941 23.1371 46.6272 21.9189C47.3134 20.7048 48.8565 20.2744 50.0706 20.9566Z",
    fill: "url(#paint9_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M55.727 53.6681C55.727 62.3536 55.727 71.0392 55.727 79.7248C55.727 80.1836 55.5159 80.61 55.1504 80.8861L53.8876 81.8444C54.2368 81.5804 54.4642 81.1581 54.4642 80.683C54.4642 71.9975 54.4642 63.3119 54.4642 54.6223C54.4642 53.8183 53.8104 53.1646 53.0065 53.1646C38.5752 53.1646 24.1399 53.1646 9.7086 53.1646C9.40812 53.1646 9.12794 53.258 8.89648 53.4123L10.0984 52.5027C10.3705 52.2997 10.6344 52.2063 10.9755 52.2063C25.4068 52.2063 39.8421 52.2063 54.2734 52.2063C55.0733 52.2103 55.727 52.8641 55.727 53.6681Z",
    fill: "url(#paint10_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.4642 54.6225C54.4642 63.3081 54.4642 71.9977 54.4642 80.6833C54.4642 81.1584 54.2368 81.5807 53.8876 81.8446C53.6439 82.0273 53.3394 82.141 53.0105 82.141C38.5792 82.141 24.1439 82.141 9.71263 82.141C8.90863 82.141 8.25488 81.4913 8.25488 80.6833C8.25488 71.9977 8.25488 63.3122 8.25488 54.6225C8.25488 54.1475 8.48227 53.7292 8.83148 53.4612L8.87615 53.4247C8.88021 53.4206 8.88833 53.4166 8.89645 53.4125C9.12791 53.2541 9.41215 53.1648 9.70857 53.1648C24.1398 53.1648 38.5752 53.1648 53.0064 53.1648C53.8104 53.1689 54.4642 53.8185 54.4642 54.6225ZM48.7428 71.5105C48.7428 71.0313 48.7428 70.5481 48.7428 70.069C48.7428 69.8659 48.5804 69.7035 48.3774 69.7035C42.3068 69.7035 36.2363 69.7035 30.1657 69.7035C29.9627 69.7035 29.8003 69.8659 29.8003 70.069C29.8003 70.5481 29.8003 71.0313 29.8003 71.5105C29.8003 71.7135 29.9627 71.8759 30.1657 71.8759C36.2363 71.8759 42.3068 71.8759 48.3774 71.8759C48.5804 71.8759 48.7428 71.7135 48.7428 71.5105ZM48.7428 66.5525C48.7428 66.0733 48.7428 65.5901 48.7428 65.111C48.7428 64.912 48.5804 64.7496 48.3774 64.7496C42.3068 64.7496 36.2363 64.7496 30.1657 64.7496C29.9627 64.7496 29.8003 64.912 29.8003 65.111C29.8003 65.5901 29.8003 66.0733 29.8003 66.5525C29.8003 66.7555 29.9627 66.9179 30.1657 66.9179C36.2363 66.9179 42.3068 66.9179 48.3774 66.9179C48.5804 66.9179 48.7428 66.7555 48.7428 66.5525ZM39.639 76.4725C39.639 75.9933 39.639 75.5101 39.639 75.031C39.639 74.8279 39.4766 74.6655 39.2736 74.6655H30.1698C29.9667 74.6655 29.8043 74.8279 29.8043 75.031V76.4725C29.8043 76.6755 29.9667 76.8379 30.1698 76.8379H39.2736C39.4725 76.8339 39.639 76.6714 39.639 76.4725ZM38.5305 58.472C38.6198 58.273 38.6685 58.0497 38.6685 57.8182C38.6685 56.9208 37.9417 56.1899 37.0403 56.1899C33.2517 56.1899 29.4673 56.1899 25.6788 56.1899C25.6016 56.1899 25.5285 56.194 25.4514 56.2062C24.6596 56.3158 24.0505 56.998 24.0505 57.8182C24.0505 58.7197 24.7773 59.4465 25.6788 59.4465C29.4673 59.4465 33.2517 59.4465 37.0403 59.4465C37.7062 59.4424 38.2787 59.0445 38.5305 58.472ZM27.5182 76.8339V64.7455C27.5182 64.3435 27.1934 64.0187 26.7914 64.0187C22.7633 64.0187 18.7352 64.0187 14.7031 64.0187C14.3011 64.0187 13.9762 64.3435 13.9762 64.7455C13.9762 68.7736 13.9762 72.8017 13.9762 76.8339C13.9762 77.2359 14.3011 77.5607 14.7031 77.5607C14.9142 77.5607 15.1213 77.5607 15.3325 77.5607C18.9423 77.5607 22.5521 77.5607 26.162 77.5607C26.3691 77.5607 26.5802 77.5607 26.7914 77.5607C27.1934 77.5648 27.5182 77.2359 27.5182 76.8339Z",
    fill: "url(#paint11_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7427 70.0691C48.7427 70.5482 48.7427 71.0315 48.7427 71.5106C48.7427 71.7136 48.5803 71.8761 48.3773 71.8761C42.3067 71.8761 36.2362 71.8761 30.1656 71.8761C29.9626 71.8761 29.8002 71.7136 29.8002 71.5106C29.8002 71.0315 29.8002 70.5482 29.8002 70.0691C29.8002 69.8661 29.9626 69.7036 30.1656 69.7036C36.2362 69.7036 42.3067 69.7036 48.3773 69.7036C48.5803 69.7036 48.7427 69.8661 48.7427 70.0691Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7427 65.1111C48.7427 65.5903 48.7427 66.0735 48.7427 66.5526C48.7427 66.7557 48.5803 66.9181 48.3773 66.9181C42.3067 66.9181 36.2362 66.9181 30.1656 66.9181C29.9626 66.9181 29.8002 66.7557 29.8002 66.5526C29.8002 66.0735 29.8002 65.5903 29.8002 65.1111C29.8002 64.9122 29.9626 64.7498 30.1656 64.7498C36.2362 64.7498 42.3067 64.7498 48.3773 64.7498C48.5803 64.7498 48.7427 64.9122 48.7427 65.1111Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6388 75.0269C39.6388 75.5061 39.6388 75.9893 39.6388 76.4685C39.6388 76.6715 39.4764 76.8339 39.2733 76.8339H30.1695C29.9665 76.8339 29.8041 76.6715 29.8041 76.4685V75.0269C29.8041 74.8239 29.9665 74.6615 30.1695 74.6615H39.2733C39.4723 74.6656 39.6388 74.828 39.6388 75.0269Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.3031 58.4882C38.3762 58.4882 38.4534 58.4841 38.5305 58.4719C38.2788 59.0445 37.7062 59.4465 37.0403 59.4465C33.2518 59.4465 29.4673 59.4465 25.6788 59.4465C24.7774 59.4465 24.0505 58.7196 24.0505 57.8182C24.0505 56.998 24.6596 56.3158 25.4514 56.2061C24.9763 57.2822 25.7641 58.4882 26.9417 58.4882C30.7261 58.4882 34.5146 58.4882 38.3031 58.4882Z",
    fill: "url(#paint12_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5182 64.7496V76.8379C27.5182 77.2399 27.1934 77.5647 26.7914 77.5647C26.5843 77.5647 26.3731 77.5647 26.162 77.5647C25.6991 74.9375 23.413 73.021 20.7452 73.021C18.0774 73.021 15.7953 74.9335 15.3324 77.5647C15.1213 77.5647 14.9142 77.5647 14.703 77.5647C14.301 77.5647 13.9762 77.2358 13.9762 76.8379C13.9762 72.8098 13.9762 68.7777 13.9762 64.7496C13.9762 64.3476 14.301 64.0227 14.703 64.0227C18.7311 64.0227 22.7633 64.0227 26.7914 64.0227C27.1934 64.0187 27.5182 64.3435 27.5182 64.7496ZM22.9501 70.7755C23.6322 69.5573 23.2018 68.0183 21.9877 67.3321C20.7695 66.6499 19.2306 67.0804 18.5443 68.2945C17.8581 69.5086 18.2926 71.0516 19.5067 71.7378C20.7249 72.4241 22.2638 71.9896 22.9501 70.7755Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.1622 77.5646C22.5523 77.5646 18.9425 77.5646 15.3326 77.5646C15.7955 74.9375 18.0816 73.0209 20.7454 73.0209C23.4132 73.0209 25.6952 74.9334 26.1622 77.5646Z",
    fill: "url(#paint13_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21.9838 67.332C23.2019 68.0142 23.6324 69.5572 22.9461 70.7754C22.2599 71.9936 20.7209 72.424 19.5028 71.7378C18.2846 71.0515 17.8542 69.5126 18.5404 68.2944C19.2267 67.0762 20.7697 66.6499 21.9838 67.332Z",
    fill: "url(#paint14_linear)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M94.5582 4H93.8557V7.9753H94.5582V4Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M96.1947 5.63614H92.2194V6.33862H96.1947V5.63614Z",
    fill: "url(#paint16_linear)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.7143 24.8376H19.7333V30.389H20.7143V24.8376Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M22.9996 27.1227H17.4482V28.1037H22.9996V27.1227Z",
    fill: "url(#paint18_linear)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M81.8939 83.6742H81.1295V87.9998H81.8939V83.6742Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M83.6745 85.4547H79.3489V86.2191H83.6745V85.4547Z",
    fill: "url(#paint20_linear)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0166 44.0147C30.4968 44.2178 29.908 44.0026 29.6482 43.5112C29.6279 43.4747 29.6076 43.4381 29.5791 43.4097C29.3761 43.1823 29.031 43.162 28.8036 43.361C28.6655 43.4828 28.5965 43.6655 28.6249 43.8483C28.629 43.8889 28.6411 43.9295 28.6574 43.966C28.8604 44.4858 28.6452 45.0746 28.1539 45.3344C28.1173 45.3547 28.0808 45.375 28.0524 45.4035C27.825 45.6065 27.8047 45.9516 28.0036 46.179C28.1255 46.3171 28.3082 46.3861 28.4909 46.3577C28.5315 46.3536 28.5721 46.3415 28.6087 46.3252C29.1284 46.1222 29.7172 46.3374 29.9771 46.8287C29.9974 46.8653 30.0177 46.9018 30.0461 46.9302C30.2491 47.1576 30.5943 47.1779 30.8217 46.979C30.9597 46.8571 31.0288 46.6744 31.0003 46.4917C30.9963 46.4511 30.9841 46.4105 30.9679 46.3739C30.7648 45.8542 30.98 45.2654 31.4714 45.0055C31.5079 44.9852 31.5445 44.9649 31.5729 44.9365C31.8003 44.7335 31.8206 44.3883 31.6216 44.1609C31.4998 44.0229 31.3171 43.9538 31.1343 43.9823C31.0978 43.9863 31.0572 43.9985 31.0166 44.0147Z",
    fill: "url(#paint21_linear)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.848 33.4181C109.032 33.4181 109.993 32.4577 109.993 31.273C109.993 30.0883 109.032 29.128 107.848 29.128C106.663 29.128 105.703 30.0883 105.703 31.273C105.703 32.4577 106.663 33.4181 107.848 33.4181Z",
    fill: "#D0D4DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.255005,
    y: 1.83905,
    width: 123.013,
    height: 96.3021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 79.8518,
    y: 45.9671,
    width: 14.3573,
    height: 4.29828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i",
    x: 52.3979,
    y: 7.81412,
    width: 14.3577,
    height: 4.29828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i",
    x: 24.3108,
    y: 54.1898,
    width: 14.3577,
    height: 4.29829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 84.2194,
    y: 0,
    width: 23.9753,
    height: 23.9753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 9.44824,
    y: 20.8376,
    width: 25.5514,
    height: 25.5514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 71.3489,
    y: 79.6742,
    width: 24.3256,
    height: 24.3257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 19.8671,
    y: 39.2244,
    width: 23.8911,
    height: 23.8911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 97.7026,
    y: 25.128,
    width: 24.2902,
    height: 24.2902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 64.381,
    y1: 58.785,
    x2: 111.267,
    y2: 58.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 63.7958,
    y1: 59.43,
    x2: 110.005,
    y2: 59.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 79.5911,
    y1: 49.6001,
    x2: 94.0711,
    y2: 49.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 70.8728,
    y1: 67.0681,
    x2: 81.7036,
    y2: 67.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 73.7603,
    y1: 61.3116,
    x2: 78.816,
    y2: 61.3116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 36.9265,
    y1: 20.6534,
    x2: 83.8128,
    y2: 20.6534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 36.3411,
    y1: 21.2792,
    x2: 82.5488,
    y2: 21.2792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 52.1361,
    y1: 11.4494,
    x2: 66.6162,
    y2: 11.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 43.4165,
    y1: 28.9181,
    x2: 54.249,
    y2: 28.9181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 46.3043,
    y1: 23.1619,
    x2: 51.3603,
    y2: 23.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 8.89571,
    y1: 67.0277,
    x2: 55.7253,
    y2: 67.0277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 8.25362,
    y1: 67.6526,
    x2: 54.4631,
    y2: 67.6526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 24.0489,
    y1: 57.8233,
    x2: 38.5307,
    y2: 57.8233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 15.331,
    y1: 75.2922,
    x2: 26.1618,
    y2: 75.2922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 18.2182,
    y1: 69.5357,
    x2: 23.2744,
    y2: 69.5357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 93.8545,
    y1: 5.98826,
    x2: 94.5555,
    y2: 5.98826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 92.2178,
    y1: 5.98709,
    x2: 96.1943,
    y2: 5.98709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 19.7316,
    y1: 27.6142,
    x2: 20.7105,
    y2: 27.6142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 17.446,
    y1: 27.6128,
    x2: 22.9991,
    y2: 27.6128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 81.1282,
    y1: 85.8377,
    x2: 81.891,
    y2: 85.8377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 79.3472,
    y1: 85.8366,
    x2: 83.6741,
    y2: 85.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 28.4037,
    y1: 46.5818,
    x2: 31.228,
    y2: 43.7575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUserGroups);
export default __webpack_public_path__ + "static/media/thumb_user_groups.497bcf934fd08402f7155811c31ad07f.svg";
export { ForwardRef as ReactComponent };